export default __webpack_public_path__ + "static/media/driver-slide1.8f1d80d8.jpg";